import { BUILTIN_ALIAS_VERSION } from "./types.js";
const alias = (targetField, keys, ordinal = false) => keys.map((key) => Object.freeze({ key, targetField, ordinal }));
/**
 * The built-in alias set, version `BUILTIN_ALIAS_VERSION`. A key is a normalized header (see
 * `headerKey`: lower case, letters and digits only), so `Event City`, `event_city` and `EventCity` are
 * all `eventcity`. A target field's own key is always an exact match and is not listed here.
 *
 * Code review owns this list. A change to it raises `BUILTIN_ALIAS_VERSION`, and a test pins the
 * list so a change cannot go unseen.
 */
export const builtinImportAliases = Object.freeze([
    ...alias("name", ["name", "eventname", "title", "itemname"]),
    ...alias("location_city", ["eventcity", "city", "locality", "town"]),
    ...alias("country_code", ["country", "countrycode"]),
    ...alias("region", ["region", "state"]),
    ...alias("address_text", ["address", "venueaddress"]),
    ...alias("venue_name", ["venue", "venuename", "location"]),
    ...alias("description", ["description", "details"]),
    ...alias("short_description", ["summary", "shortdescription"]),
    ...alias("start_day", ["day", "eventday"]),
    ...alias("start_month", ["month", "eventmonth"]),
    ...alias("start_year", ["year", "eventyear"]),
    ...alias("start_time", ["time", "starttime", "eventtime"]),
    ...alias("start_date", ["date", "eventdate", "startdate"]),
    ...alias("time_zone", ["timezone", "tz"]),
    ...alias("performers", ["celebrity", "performer", "artist"], true),
    ...alias("price_text", ["price", "cost", "ticketprice"]),
    ...alias("price_currency", ["currency"]),
    ...alias("external_url", ["url", "website", "link"]),
    ...alias("source_key", ["id", "legacyid", "eventid"]),
    ...alias("item_type", ["type", "itemtype"]),
    ...alias("category", ["category"]),
    // Version 2 (CHT-1950).
    ...alias("google_place_id", ["googleplaceid", "placeid", "gmapsplaceid", "googlemapsid"]),
]);
export { BUILTIN_ALIAS_VERSION };
